export default "__VITE_ASSET__SUXjzpG5__"